import { createRoot } from "react-dom/client";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { library } from "@fortawesome/fontawesome-svg-core";
import { far } from "@fortawesome/free-regular-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { reactErrorHandler } from "@sentry/react";

import App from "@/App";
import { initializeSentry } from "./utils/sentry";

import "./styles/index.css";
import { initializeI18n } from "./utils/i18n";

initializeI18n();
initializeSentry();

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element not found");
}

/**
 * Call the element loader before the render call
 * @see https://capacitorjs.com/docs/web/pwa-elements
 */
defineCustomElements(window);

/**
 * Add the font awesome icons in order to use
 * them in our tags component
 */
library.add(far, fas);

const reactRoot = createRoot(root, {
  onUncaughtError: reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
});

reactRoot.render(<App />);
